import { occFetch } from "~/app/api/occ/occFetch";
import { checkoutAddressUrl } from "./checkoutAddressUrl";

export function sendData(activeCartId: string, addressId: string, temporary?: boolean): Promise<Response> {
  if (temporary !== undefined) {
    return occFetch(
      checkoutAddressUrl(
        activeCartId,
        `/checkout/multi/summary/selectaddress/${temporary}/${encodeURIComponent(addressId)}`,
      ),
      { method: "POST" },
    );
  } else {
    const url = checkoutAddressUrl(activeCartId, "/checkout/multi/summary/selectaddress");
    return occFetch(`${url}?selectedAddressCode=${encodeURIComponent(addressId)}`, { method: "POST" });
  }
}
